import { ImsPanelService } from 'app/shared/ims_panel.service';
import { IMSVisualiser } from 'app/views/visualiser';
import { isNotNil } from 'app/shared/utils';
import ColorRenderer from 'app/shared/utilities/color_renderer';

export const doVisualiserPointsExist = (visualiser: IMSVisualiser): boolean => {
    let visualiserPointsExists = !!visualiser && !!visualiser.colorRenderer;
    if (visualiser && visualiser.colorRenderer) {
        visualiserPointsExists = (visualiser.colorRenderer as ColorRenderer).points !== undefined;
    }

    return visualiserPointsExists;
};

export class ColorLegendService {
    private _imsPanelService: ImsPanelService;

    constructor(imsPanelService: ImsPanelService) {
        this._imsPanelService = imsPanelService;
    }

    public async refreshColorLegendPanel(tag: string, visualiser: IMSVisualiser) {
        const api = isNotNil(tag) ? this._imsPanelService.getPanelApiByTag(tag) : null;
        const visualiserPointsExists = doVisualiserPointsExist(visualiser);

        if (api) {
            if (!visualiserPointsExists) {
                await this._imsPanelService.closePanel(api.id);
                return;
            }
            api.updateData({ visualiser: () => visualiser });
        }
    }

    public async openColorLegendPanel(tag: string, visualiser: IMSVisualiser) {
        const api = isNotNil(tag) ? this._imsPanelService.getPanelApiByTag(tag) : null;
        const visualiserPointsExists = doVisualiserPointsExist(visualiser);

        if (!api) {
            if (!visualiserPointsExists) {
                return;
            }
            this._imsPanelService.newPanel('detached', {
                tag,
                headerText: `Colour Legend`,
                darkTheme: true,
                // using a getter function here because all inner component data is deep cloned, and you can't deep clone a class instance like this (recursive). Copying a JS function is somehow okay though.
                innerComponentData: { visualiser: () => visualiser },
                persistent: false,
                resizable: false,
                detachedWidth: 230,
                detachedHeight: undefined,
                innerComponent: 'colorLegend',
            });
        } else {
            if (!visualiserPointsExists) {
                await this._imsPanelService.closePanel(api.id);
                return;
            }
            api.updateData({ visualiser: () => visualiser });
        }
    }
}
